import { Amplify } from "aws-amplify";

Amplify.configure({
  Auth: {
    Cognito: {
      identityPoolId: import.meta.env.VITE_AWS_COGNITO_IDENTITY_POOL_ID,
      userPoolId: import.meta.env.VITE_AWS_COGNITO_USER_POOL_ID,
      userPoolClientId: import.meta.env.VITE_AWS_COGNITO_USER_POOL_CLIENT_ID,
      allowGuestAccess: false,
      loginWith: {
        email: true,
        username: true,
        phone: true,
      },
    },
  },
});
